
import { MapTo } from '@adobe/aem-react-editable-components';
import ReviewsExpanding, { ReviewsExpandingEditConfig } from './ReviewsExpanding';

export default MapTo('cob-corp-acquisition/components/creditonebank/reviews-expanding')(ReviewsExpanding, ReviewsExpandingEditConfig);
        